
import LivPlusContainer from '~/js/views/general/components/liv-plus/LivPlusContainer';

// Variable Declaration
const treatments = query('#liv-plus');

// Render react component
ReactDOM.render(<LivPlusContainer />, treatments);
